import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "times-up-content" }
const _hoisted_2 = { class: "text-lg" }

import { computed, ref } from 'vue'
import Modal from './Modal.vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['onBackHome'],
  setup(__props, { expose, emit }) {

const quitModal = ref<InstanceType<typeof Modal> | null>(null)



const isShown = computed(() => quitModal.value?.isShown)

async function show() {
  quitModal.value?.show()
}
async function hide() {
  quitModal.value?.hide()
}

function backToHome() {
  emit('onBackHome')
}

expose({
  show,
  hide,
  isShown,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "quitModal",
    ref: quitModal,
    class: "modal-times-up",
    title: _ctx.$t('quitModal.title'),
    "validate-btn-text": _ctx.$t('general.returnHomeScreen'),
    "cancel-btn-text": _ctx.$t('general.cancel'),
    onOnValidateClick: backToHome
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('quitModal.text')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "validate-btn-text", "cancel-btn-text"]))
}
}

})